import { Button } from 'react-bootstrap';
import DietaryRestrictionsFilter from './DietaryRestrictionsFilter';
import DietFilter from './DietFilter';
import MacroFilter from './MacroFilter';
import ProductTypeFilter from './ProductTypeFilter';
import ProteinFilter from './ProteinFilter';
import SortFilter from './SortFilter';
import ProductSearch from './ProductSearch';
import './productFilters.scss';
import ProductFilterTags from './ProductFilterTags';
import { clearDietaryRestrictions,
  selectProductSortFilter,
  setProductCalorieFilter,
  setProductCarbFilter,
  setProductDietFilter, 
  setProductFatFilter,
  setProductProteinFilter,
  setProductProteinTypeFilter, 
  setProductSearchFilter, 
  setProductSortFilter, 
  setProductTypeFilter } from '../productsSlice';
import { useDispatch, useSelector } from 'react-redux';


export default function ProductFilters() {
  const dispatch = useDispatch();
  const sortFilter = useSelector(selectProductSortFilter);
  const handleReset = () => {
    dispatch(setProductTypeFilter('all'));
    dispatch(setProductProteinTypeFilter('all'));
    dispatch(setProductDietFilter('all'));
    dispatch(clearDietaryRestrictions());
    dispatch(setProductCalorieFilter({ min: 0, max: 1200 }));
    dispatch(setProductCarbFilter({ min: 0, max: 250 }));
    dispatch(setProductFatFilter({ min: 0, max: 100 }));
    dispatch(setProductProteinFilter({ min: 0, max: 150 }));
    dispatch(setProductSearchFilter(''));
    dispatch(setProductSortFilter('none'));
  }

  const handleMostPopularClick = () => {
    const newSortFilter = sortFilter === 'most_popular' ? 'none' : 'most_popular';
    dispatch(setProductSortFilter(newSortFilter));
  };

  return (
    <div className='product-filters bg-white pt-3 px-2 pb-3 w-100'>
      <div className='d-flex'>
        <div className='fs-2 fw-normal me-2 d-none d-lg-block '>Filter:</div>
        <div className='d-flex flex-wrap wrapfilter'>
          <div className='d-flex flex-wrap col-md-8 col-xxl-auto top-wrapFilter'>
            <div className='p-1 col-md-6 col-xxl-auto'><ProductTypeFilter /></div>
            <div className='p-1 col-md-6 col-xxl-auto'><ProteinFilter /></div>
            <div className='p-1 col-md-6 col-xxl-auto'><DietFilter /></div>
            <div className='p-1 col-md-6 col-xxl-auto'><DietaryRestrictionsFilter /></div>
            <div className='p-1 col-md-6 col-xxl-auto'><MacroFilter /></div>
            <div className='p-1 col-md-6 col-xxl-auto'><SortFilter /></div>
          </div>
          <div className='d-flex flex-wrap col-md-4 col-xxl-auto bottom-wrapFilter'>
            <div className='p-1 col-12 col-xxl-auto'><ProductSearch /></div>
            <div className='p-1 col-12 col-xxl-auto'>
              <Button
                variant="dark"
                className='reset-filters-btn w-100 border border-black text-black'
                onClick={handleReset}
              >
                Reset All
              </Button>
            </div>
            <div className='p-1 col-12 col-xxl-auto'>
              <Button
                variant={sortFilter === 'most_popular' ? 'success' : 'dark'}
                className={`${sortFilter === 'most_popular' ? 'popular-meal-success-btn' : 'popular-meal-unsuccess-btn' } w-100 border border-black`}
                onClick={handleMostPopularClick}
              >
                Most Popular
              </Button>
            </div>
          </div>
        </div>
      </div>
      <ProductFilterTags />
    </div>
  );
}